import React from "react";
import { GetServerSideProps } from "next";
import PubSubProvider from "@livepix/components/pubsub/PubSubProvider";
import { WidgetData } from "../../lib/types";
import { isValidUuid } from "../../lib/validation";
import useWebservice from "../../hooks/useWebservice";
import WidgetEmbed from "../../components/WidgetEmbed";

type Props = {
  widgetId: string;
};

export const getServerSideProps: GetServerSideProps<Props> = async (
  context,
) => {
  if (!context.params?.widgetId) return { notFound: true };

  const { widgetId } = context.params;

  if (typeof widgetId !== "string" || !isValidUuid(widgetId))
    return { notFound: true };

  return { props: { widgetId } };
};

export default function EmbedWidgetPage({ widgetId }: Props) {
  const webservice = useWebservice();

  const [data, setData] = React.useState<WidgetData>();

  React.useEffect(() => {
    webservice
      .get<WidgetData>(`/widgets/${widgetId}`)
      .then(({ data }) => {
        setData(data);
      })
      .catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <PubSubProvider tokenEndpoint={`/pubsub/widget/${widgetId}`}>
      <WidgetEmbed widgetId={widgetId} {...data} />
    </PubSubProvider>
  );
}
